import { createState } from '@hookstate/core';
import { Persistence } from '@hookstate/persistence';
import getInitialGlobalStateValues from './InitialGlobalStateValues';
import {
  IntegratedPartnerType,
  PaymentTypeEnum,
  HouseHoldEnum,
  BusinessTypeEnum,
  FlowEnum,
  ReferenceLabelType,
} from '../../types';

export interface AppStoreType {
  progress?: number;
  flow?: FlowEnum;
  ref?: string;
  partnerReference?: string;
  partner?: IntegratedPartnerType;
  subscription?: string;
  firstName?: string;
  lastName?: string;
  salutation?: string;
  email?: string;
  referenceLabelType?: ReferenceLabelType;
}

export interface QuestionState {
  isDone?: boolean;
  household?: HouseHoldEnum;
  apartmentSize?: number;
  postcode?: string;
  paymentType?: PaymentTypeEnum;
  paymentAmount?: string;
  periodMonthFrom?: number;
  periodYearFrom?: number;
  periodMonthTo?: number;
  periodYearTo?: number;
  deliverAt?: string;
  rentalFee?: number;
  landlord?: string;
  hasLegalInsurance?: boolean;
  hasUnionOptions?: boolean;
  legalInsurance?: string;
  businessType?: BusinessTypeEnum;
  locationAmount?: string;
  reference?: string;
  referenceLabel?: string;
}

export interface ProductState {
  id?: string;
  price?: string;
  name?: string;
}

export interface GlobalStateType {
  AppStore: AppStoreType;
  Question: QuestionState;
  Product: ProductState;
}

const initialValues = getInitialGlobalStateValues();
const globalState = createState<GlobalStateType>(initialValues);

// in the is24 iframe localstorage access can be denied when browser is configured to deny 3rd party access
// for that case we want to only optionaly use the persistance when available, but we don't want to prevent the app from loading
try {
  globalState.attach(Persistence('mineko-de-order-app'));
} catch (e) {
  console.error(e);
}

export default globalState;
